import React, {useContext, useEffect, useRef, useState} from "react";
import {TranslateContext} from "../../context/TranslateContext";
import {renderAsync} from 'docx-preview';
import {useHistory} from "react-router-dom";
import {getGraficiKpiApi, getReportKpiApi} from "./services/ExportKpiServices";
import ExportKpiView from "./ExportKpiView";
import {getListaKpiApi} from "../kpi/services/KpiServices";

export default function ExportKpiController() {

    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState('');
    const [listaKpi, setListaKpi] = useState([]);
    const [listaGrafici, setGraficiKpi] = useState([]);
    const [showAnteprimaDoc, setShowAnteprimaDoc] = useState(false);
    const [fileAnteprima, setFileAnteprima] = useState();

    const containerRef = useRef(null);
    const {translate, lingua, loadingNewLang} = useContext(TranslateContext);
    const history = useHistory();

    async function getListaKpi() {
        const response = await getListaKpiApi();
        setListaKpi(response.data.data);
    }

    async function getGraficiKpi() {
        const response = await getGraficiKpiApi();
        setGraficiKpi(response.data.data);
    }

    async function anteprimaExportKpi() {
        const response = await getReportKpiApi(listaKpi);
        if (response.data.result === 0) {
            let resp = response.data.data;

            var byteCharacters = atob(resp.contenuto);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            const file = new Blob([byteArray], {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'});

            setFileAnteprima(file);
            setShowAnteprimaDoc(true);
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    async function downloadReportKpi() {
        const response = await getReportKpiApi(listaKpi);
        if (response.data.result === 0) {
            let resp = response.data.data;

            const file = getBlobFileAnteprima(resp);
            var fileURL = URL.createObjectURL(file);

            window.open(fileURL);
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    const getBlobFileAnteprima = (resp) => {
        var byteCharacters = atob(resp.contenuto);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'});
    };

    useEffect(() => {
        if (loadingNewLang === false) {
            getListaKpi();
            getGraficiKpi();
        }
    }, [lingua, loadingNewLang]);

    useEffect(() => {
        if (fileAnteprima && containerRef.current) {
            renderAsync(fileAnteprima, containerRef.current);
        }
    }, [fileAnteprima]);

    const bottoniSx = [
        {
            icon: 'fas fa-angle-left',
            command: () => {
                history.goBack();
            }
        }
    ];

    const bottoniDx = [
        {
            label: translate("Anteprima"),
            icon: "fas fa-eye",
            command: anteprimaExportKpi
        },
        {
            label: translate("Scarica"),
            icon: "fas fa-download",
            command: downloadReportKpi
        }
    ];

    function onChangeGrafici(event, row) {
        let listaKpiNew = JSON.parse(JSON.stringify(listaKpi));
        for (let i = 0; i < listaKpiNew.length; i++) {
            if (listaKpiNew[i].id_kpi === row.id_kpi) {
                listaKpiNew[i].id_grafico = event.target.value;
            }
        }
        setListaKpi(listaKpiNew);
    }

    function onChangeAllExport(event) {
        let listaKpiNew = JSON.parse(JSON.stringify(listaKpi));
        for (let i = 0; i < listaKpiNew.length; i++) {
            if (event.target.checked) {
                listaKpiNew[i].export = 1;
            } else {
                listaKpiNew[i].export = 0;
            }
        }
        setListaKpi(listaKpiNew);
    }

    function onChangeExport(event, row) {
        let listaKpiNew = JSON.parse(JSON.stringify(listaKpi));
        for (let i = 0; i < listaKpiNew.length; i++) {
            if (listaKpiNew[i].id_kpi === row.id_kpi) {
                if (event.target.checked) {
                    listaKpiNew[i].export = 1;
                } else {
                    listaKpiNew[i].export = 0;
                }
            }
        }
        setListaKpi(listaKpiNew);
    }

    return (
        <ExportKpiView
            translate={translate}
            show={show}
            modalMsg={modalMsg}
            fileAnteprima={fileAnteprima}
            listaKpi={listaKpi}
            listaGrafici={listaGrafici}
            containerRef={containerRef}
            setShow={setShow}
            setShowAnteprimaDoc={setShowAnteprimaDoc}
            showAnteprimaDoc={showAnteprimaDoc}
            bottoniSx={bottoniSx}
            bottoniDx={bottoniDx}
            onChangeAllExport={onChangeAllExport}
            onChangeExport={onChangeExport}
            onChangeGrafici={onChangeGrafici}
        />
    );
}